export class AbstractModel {
  deserialize(input: any): this {
    let model: any = this;

    // Hydrate properties
    for (const propertyName in model) {
      if (propertyName in input) {
        model[propertyName] = input[propertyName];
      }
    }

    for (const index in input) {
      if (index.endsWith('At')) {
        if (input[index] === null) {
          if (index in model) {
            model[index] = null;
          }
        } else {
          const date = new Date(input[index]);
          model[index] = date.toString() !== 'Invalid Date' ? date : null;
        }
      }
    }

    return this;
  }
}
